/*=========================================================================================
  File Name: module-auth-actions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import httpClient from '../../api/axios-httpclient';

export default {
	updateAccessToken: function(context, value) {
		context.commit('updateAccessToken', value);
	},

	updateUserInfo: function(context, value) {
		context.commit('updateUserInfo', value);
	},

	logout: function(context, value) {
		context.commit('logout', value);
	}
};
